import { BadgeVariant, IconRegistry } from '@percent/lemonade'
import { OrganisationTypes } from '../types/application.types'

enum OrgTypes {
  na = 'na',
  pending = 'pending'
}

type OrganisationTypeBadgeVariant = {
  status: BadgeVariant
  icon?: keyof typeof IconRegistry
  text: string
}

type getOrgTypesTypes = {
  organisationTypes?: OrganisationTypes[] | string[] | [] | Record<string, 'yes' | 'no' | 'unknown'> | null
  rejectedAt?: string | null
  organisationId?: string | null
}

export const getOrgTypes = ({ organisationTypes, rejectedAt, organisationId }: getOrgTypesTypes) => {
  if ((organisationTypes?.length === 0 && rejectedAt && !organisationId) || organisationTypes === null) {
    return [OrgTypes.na]
  }

  if (organisationTypes && Array.isArray(organisationTypes) && organisationTypes.length >= 1) {
    return organisationTypes
  }

  if (typeof organisationTypes === 'object' && Object.keys(organisationTypes).length > 0) {
    return Object.keys(organisationTypes).filter(
      key => organisationTypes[key as keyof typeof organisationTypes] === 'yes'
    ) as OrganisationTypes[]
  }

  return [OrgTypes.pending]
}

export const mapOrganisationTypes = (organisationType: string): OrganisationTypeBadgeVariant => {
  switch (organisationType) {
    case OrgTypes.pending:
      return {
        status: 'default',
        icon: 'clock',
        text: 'status.pending'
      }
    case OrgTypes.na:
      return {
        status: 'default',
        icon: undefined,
        text: 'status.notAvailable'
      }
    default:
      return {
        status: 'informative',
        icon: 'categories',
        text: `organisationTypes.${organisationType}`
      }
  }
}
